import { render, staticRenderFns } from "./ScannerBlock.vue?vue&type=template&id=e47ae3a2&scoped=true"
import script from "./ScannerBlock.vue?vue&type=script&lang=js"
export * from "./ScannerBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e47ae3a2",
  null
  
)

export default component.exports